import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  InputLabel,
  TextField,
  Box,
} from "@mui/material";
import React, { useEffect, useRef } from "react";
import MDButton from "../../../components/MDButton/index";
import Grid from "@mui/material/Grid";
import { useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import Checkbox from "@mui/material/Checkbox";
import { useForm } from "react-hook-form";
import MDInput from "../../../components/MDInput";
import { CompanyTypeDialogValidation } from "util/validations/commonValidations";
import { useDispatch,useSelector } from "react-redux";
import { addCompany } from "../Redux/actionCreator";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import { setPhoto } from "../../../layouts/events/Redux/actionCreator";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const CompanyTypeDialog = ({ handleDialogClose }) => {
  const dispatch=useDispatch();
  const { Company_Data } = useSelector((state) => state.common);
 
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(CompanyTypeDialogValidation),
  });
  const selectOptions = [
    {
      key: "Organization",
      value: "Organization",
    },
    {
      key: "SuperAdmin",
      value: "Super_Admin",
    },
    {
      key: "Applicant",
      value: "Applicant",
    },
  ];
  const [openDialog, setOpenDialog] = useState(false);
  const handleOpenDialog = (event) => setOpenDialog(event.currentTarget);
  const handleCloseDialog = () => setOpenDialog(false);
  const [uploadedFile, setUploadedFile] = useState(null);
  const fileInputRef = useRef(null);
  const [selectedFileName, setSelectedFileName] = useState("");
  const [iconUrl, setIconUrl] = useState("");
  const onSubmit = (data) => {

     const payload = {
       name: data.name,
       files: uploadedFile,
     };
      //  console.log("Company payload:", payload);

 
    dispatch(addCompany(payload));
    handleDialogClose();
    
  };

  const handleFileIconClick = () => {
    fileInputRef.current?.click();
  };

  const handleFileChange = (event) => {
  const file = event.target.files?.[0];

  if (!file) return;

  setSelectedFileName(file.name);

  dispatch(setPhoto(file))
    .then((response) => {
      console.log("Upload response:", response);

      const fileData = response?.payload?.data?.data?.[0];

      if (!fileData) {
        throw new Error("File upload response not found");
      }

      const fileDetails = {
        location: fileData.location,
        fileName: fileData.fileName || file.name,
        uri: fileData.uri,
        bucket: fileData.bucket,
        region: fileData.region,
        mimeType: fileData.mimeType || file.type,
        secureUrl: fileData.secureUrl,
        url: fileData.url,
        isSecured: fileData.isSecured,
        cdnUrl: fileData.cdnUrl,
      };

      setUploadedFile(fileDetails);
    })
    .catch((error) => {
      console.error("Error uploading file:", error);
    });
};
  

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Name
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <MDInput
              placeholder=""
              sx={{ width: "100%", marginTop: "0.4rem" }}
              inputProps={{
                style: { fontSize: 15, fontWeight: "bold" },
              }}
              {...register("name")}
              error={errors?.name?.message}
              helperText={errors?.name?.message}
            />
          </Grid>

          <Grid item xs={4}>
            <InputLabel fullWidth className="input-labels">
              Upload Icon
            </InputLabel>
          </Grid>

          <Grid item xs={8}>
            <form noValidate>
              <Box display="flex" alignItems="center">
                <MDInput
                  // onKeyDown={(e) => {
                  //     e.key === "Enter" && e.preventDefault();
                  //   }}
                  placeholder="Upload Client Logo"
                  sx={{ width: "100%", marginTop: "1rem" }}
                  inputProps={{
                    style: { fontSize: 15, fontWeight: "bold" },
                  }}
                  //   value={logoName ? logoName : selectedFileName}
                  value={selectedFileName}
                  readOnly
                />

                <AttachFileIcon
                  style={{
                    width: "2rem",
                    height: "2rem",
                    marginTop: "1rem",
                    marginLeft: "0.5rem",
                    cursor: "pointer",
                  }}
                  onClick={handleFileIconClick}
                />
                <input
                  ref={fileInputRef}
                  type="file"
                  style={{ display: "none" }}
                  // accept=".img, .png"
                  onChange={handleFileChange}
                />
              </Box>
            </form>
          </Grid>
        </Grid>

        <MDButton
          variant="contained"
          color="info"
          type="submit"
          sx={{ marginTop: "1.5rem" }}
        >
          create
        </MDButton>
        {/* <MDButton variant="text" color="info" onClick={handleCloseDialog}>
                cancel
              </MDButton> */}
      </form>
    </div>
  );
};

export default CompanyTypeDialog;
